// src/components/admin/OrganizationsList.js
import React from 'react';
import RefDictionaryPage from './RefDictionaryPage';

export default function OrganizationsList() {
  return (
    <RefDictionaryPage
      breadcrumbs="Справочники"
      title="Организации"
      subtitle="Юридические лица, от которых заключаются договоры"
      endpoint="v1/organizations"
      listMapper={(raw) => (Array.isArray(raw) ? raw.filter((o) => !o.is_deleted) : [])}
      searchKeys={['name', 'bin']}
      columns={[
        { key: 'id',  label: 'ID',  width: 80 },
        { key: 'name', label: 'Название' },
        { key: 'bin', label: 'БИН', width: 180 },
        {
          key: 'is_individual',
          label: 'Тип',
          width: 160,
          render: (v) => (
            <span className={`crmpage__status crmpage__status--${v ? 'info' : 'neutral'}`}>
              {v ? 'Физлицо' : 'Юр. лицо'}
            </span>
          ),
        },
      ]}
      fields={[
        { key: 'name', label: 'Название', required: true, placeholder: 'MB4' },
        { key: 'bin',  label: 'БИН', placeholder: '000146498187' },
        { key: 'is_individual', label: 'Тип', type: 'select', options: [
          { id: 'false', name: 'Юридическое лицо' },
          { id: 'true',  name: 'Физическое лицо' },
        ] },
      ]}
      emptyRecord={{ name: '', bin: '', is_individual: 'false' }}
      itemTitle={(o) => o?.name}
    />
  );
}
